var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vpn-page"},[_c('HeadNav'),_vm._v(" "),_c('main',{staticClass:"doc-page"},[_c('h1',[_vm._v("Common VPN Problems and How to Fix Them")]),_vm._v(" "),_c('DocBlocks',{attrs:{"blocks":_vm.problemBlocks}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }